module.exports = __webpack_public_path__ + "img/apps.dc720b21.png";